var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.9,65.5L54,49.7V31h6c1.7,0,3-1.3,3-3V12c0-1.7-1.3-3-3-3H34c-1.7,0-3,1.3-3,3v7H13c-1.7,0-3,1.3-3,3v7.4 C4.8,30.6,1,34,1,38s3.8,7.4,9,8.6v3.2L1.1,65.5c-0.2,0.3-0.2,0.7,0,1c0,0.1,0.1,0.1,0.2,0.2l0,0l0,0l0,0l4,4C5.5,70.9,5.7,71,6,71 h52c0.3,0,0.5-0.1,0.7-0.3l4-4l0,0l0,0l0,0c0.1-0.1,0.1-0.1,0.2-0.2C63,66.2,63,65.8,62.9,65.5z M52,49h-2V31h2V49z M27,38 c0-1.8-0.7-3.5-2-4.8V28c0-0.6-0.4-1-1-1c-0.2,0-0.4,0-0.5,0.1l-4.3,2.6c-1-0.3-2.1-0.5-3.2-0.6V25h15v3c0,1.7,1.3,3,3,3h1.8 L35,35.8c-0.1,0.5,0.3,1.1,0.8,1.2c0.3,0,0.5,0,0.7-0.2l8.7-5.8H48v18H16v-2.1C22.2,46.2,27,42.5,27,38z M33,12c0-0.6,0.4-1,1-1h26 c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1H45c-0.2,0-0.4,0.1-0.6,0.2l-7.1,4.7l0.6-3.7c0.1-0.5-0.3-1.1-0.8-1.2c-0.1,0-0.1,0-0.2,0h-3 c-0.6,0-1-0.4-1-1L33,12L33,12z M12,22c0-0.6,0.4-1,1-1h18v2H15c-0.6,0-1,0.4-1,1v5c-0.7,0-1.3,0-2,0.1V22z M3,38c0-3.9,4.9-7,11-7 c1.7,0,3.4,0.3,5,0.8c0.3,0.1,0.6,0.1,0.8-0.1l3.2-1.9v3.8c0,0.3,0.1,0.5,0.3,0.7c1,1,1.7,2.3,1.7,3.7c0,3.9-4.9,7-11,7 S3,41.9,3,38z M14,47v2h-2v-2.1C12.7,47,13.3,47,14,47z M11.6,51h40.8l7.9,14H3.7L11.6,51z M57.6,69H6.4l-2-2h55.2L57.6,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,61.6l-4-8C50.7,53.2,50.4,53,50,53H14c-0.4,0-0.7,0.2-0.9,0.6l-4,8c-0.2,0.5,0,1.1,0.4,1.3 C9.7,63,9.8,63,10,63h44c0.6,0,1-0.4,1-1C55,61.8,55,61.7,54.9,61.6z M11.6,61l3-6h34.8l3,6H11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,37C7.7,37,7,37.7,7,38.5S7.7,40,8.5,40s1.5-0.7,1.5-1.5S9.3,37,8.5,37L8.5,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,38.5c0-0.8-0.7-1.5-1.5-1.5S12,37.7,12,38.5s0.7,1.5,1.5,1.5l0,0C14.3,40,15,39.3,15,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,40c0.8,0,1.5-0.7,1.5-1.5S19.3,37,18.5,37S17,37.7,17,38.5l0,0C17,39.3,17.7,40,18.5,40z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 15,
    className: "st0",
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    className: "st0",
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    className: "st0",
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 45,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 45,
    className: "st0",
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.b04ed8a128c9849e48a091ad901becc5.svg";
export { ForwardRef as ReactComponent };